import $ from 'jQuery';
import { header_height_property } from '../components/header.js';


export default () => {
  // anchor links smooth scrolling.

  // if the header is sticky, take it in count for where the page lands
  // after scrolling
  const headerHeight = $('.l-header').outerHeight();

  if (window.location.hash) {
    const hash = window.location.hash;

    if ($(hash).length) {
      setTimeout(function () {
        const offset = $(hash).offset().top;
        $('body, html').animate({ scrollTop: offset - headerHeight + 'px'}, 800);
      }, 300);
    }
  }

  $('a.anchor-link').on('click', function (e) {
    e.preventDefault();
    const $target = $($(this).attr('href'));

    if ($target.length) {
      const scrollTo = $target.offset().top;

      $('body, html').animate({scrollTop: scrollTo - headerHeight + 'px'}, 800);
			// if the header is not sticky, use this instead
      // $('body, html').animate({ scrollTop: `${scrollTo}px` }, 800);

      setTimeout(function () {
        $target.focus();
      }, 100);
    }
  });
};
